"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableBodyCell = exports.StyledTableHeadCellInner = exports.StyledTableHeadCell = exports.StyledTableRow = exports.StyledTableBody = exports.StyledTableHead = exports.StyledTable = exports.StyledTableContainer = exports.StyledTableSection = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
exports.StyledTableSection = styled_components_1.default.section({
    backgroundColor: theme_1.colors.white,
    boxSizing: 'border-box',
    overflowX: 'hidden',
    position: 'relative'
}, function (_a) {
    var bodyOffset = _a.bodyOffset, tableBorders = _a.tableBorders, tableMinWidth = _a.tableMinWidth, tableWidth = _a.tableWidth;
    return ({
        /* tslint:disable */
        borderColor: theme_1.colors.white,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderTopColor: tableBorders.top ? theme_1.colors.grey3 : theme_1.colors.white,
        borderLeftColor: tableBorders.left ? theme_1.colors.grey3 : theme_1.colors.white,
        borderBottomColor: tableBorders.bottom ? theme_1.colors.grey3 : theme_1.colors.white,
        borderRightColor: tableBorders.right ? theme_1.colors.grey3 : theme_1.colors.white,
        paddingTop: bodyOffset,
        minWidth: tableMinWidth,
        width: tableWidth
        /* tslint:enable */
    });
});
exports.StyledTableContainer = styled_components_1.default.div({
    WebkitOverFlowScrolling: 'touch',
    borderTop: "1px solid " + theme_1.colors.grey3,
    overflowX: 'hidden',
    overflowY: 'scroll',
    width: '100%'
}, function (_a) {
    var tableHeight = _a.tableHeight;
    return ({
        height: tableHeight
    });
});
exports.StyledTable = styled_components_1.default.table(__assign(__assign({}, theme_1.font), { borderSpacing: '0px' }), function (_a) {
    var tableMinWidth = _a.tableMinWidth, tableWidth = _a.tableWidth;
    return ({
        minWidth: tableMinWidth,
        width: tableWidth
    });
});
exports.StyledTableHead = styled_components_1.default.thead({});
exports.StyledTableBody = styled_components_1.default.tbody({});
exports.StyledTableRow = styled_components_1.default.tr({});
var commonStyles = {
    backgroundColor: theme_1.colors.white,
    padding: "" + theme_1.scaffolding.sm
};
exports.StyledTableHeadCell = styled_components_1.default.th({
    border: 'none',
    color: theme_1.colors.transparent,
    fontWeight: theme_1.fontWeights.regular,
    height: '0px',
    lineHeight: '0px',
    paddingBottom: '0px',
    paddingTop: '0px',
    whiteSpace: 'nowrap'
}, function (_a) {
    var cellMinWidth = _a.cellMinWidth, cellWidth = _a.cellWidth, cellTextColor = _a.cellTextColor;
    return ({
        color: cellTextColor,
        minWidth: cellMinWidth,
        width: cellWidth
    });
});
exports.StyledTableHeadCellInner = styled_components_1.default.div(__assign(__assign({}, commonStyles), { fontSize: '11px', lineHeight: 'normal', position: 'absolute', top: '0px', whiteSpace: 'pre-line', width: 'auto' }), function (_a) {
    var cellMinWidth = _a.cellMinWidth, cellWidth = _a.cellWidth, cellTextColor = _a.cellTextColor;
    return ({
        color: cellTextColor,
        minWidth: cellMinWidth,
        width: cellWidth
    });
});
exports.StyledTableBodyCell = styled_components_1.default.td(__assign(__assign({}, commonStyles), { boxSizing: 'border-box' }), function (_a) {
    var cellBorders = _a.cellBorders, cellMinWidth = _a.cellMinWidth, cellWidth = _a.cellWidth, cellTextColor = _a.cellTextColor;
    return ({
        /* tslint:disable */
        color: cellTextColor,
        borderColor: theme_1.colors.white,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderTopColor: cellBorders.top ? theme_1.colors.grey2 : theme_1.colors.white,
        borderLeftColor: cellBorders.left ? theme_1.colors.grey2 : theme_1.colors.white,
        borderBottomColor: cellBorders.bottom ? theme_1.colors.grey2 : theme_1.colors.white,
        borderRightColor: cellBorders.right ? theme_1.colors.grey2 : theme_1.colors.white,
        minWidth: cellMinWidth,
        width: cellWidth
        /* tslint:enable */
    });
});
//# sourceMappingURL=styles.js.map